<template>
  <div class="activity-details">
    <header class="activity-header-info">
      <div class="activity-time">有效期：{{details.beginTime}}至{{details.endTime}}</div>
      <div class="activity-title">{{details.title}}</div>
      <div class="activity-text"></div>
    </header>
    <div class="details-block">
      <section class="activity-content">
        <div class="activity-icon">活动类型</div>
        <div class="activity-type">
          <span>{{details.campaignTypeDesc}} (送完即止)</span>
        </div>
      </section>
      <section class="activity-content">
        <div class="activity-icon">优惠券</div>
        <ul class="activity-condition" v-if="details.couponAmounts">
          <li class="condition-item" v-for="(item,index) in details.couponAmounts" :key="index">
            <div class="condition-info">
              <div class="info-left">
                <div>
                  赠送<div class="block">{{item.couponTypeDesc}}</div>
                </div>
                <div class="mg-top" v-if="item.templates && item.templates[0]">
                  适用{{costType[item.templates[0].costType]}}
                </div>
              </div>
              <div class="info-right">
                <div class="info-item" v-for="(child,i) in item.templates" :key="i">
                  <div class="full">满{{child.discount.condition}}减{{child.discount.discount}}</div>
                  <div class="flex">{{child.releaseNumber}}张</div>
                </div>
              </div>
            </div>
          </li>
          
        </ul>
      </section>
      <section class="activity-content" v-if="details.scope">
        <div class="activity-icon">优惠券使用范围</div>
        <template v-if="details.scope.scopeType == 3">
          <p class="p-title">可使用站点</p>
          <p class="" v-if="details.staNames">
            {{ details.staNames.join(",") }}
          </p>
        </template>
        <template v-if="details.scope.scopeType == 2">
          <p class="p-title">可使用城市</p>
          <p class="" v-if="details.cityNames">
            {{ details.cityNames.join(",") }}
          </p>
        </template>
        <template v-if="details.scope.scopeType == 1">
          无限制
        </template>
      </section>
      <section class="activity-content">
        <div class="activity-icon">活动说明</div>
        <p class="">{{details.remark}}</p>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pi-activity-2',
  props : {
    details:{
      type: Object,
      default:()=>{
        return {}
      }
    }
  },
  data(){
    return {
      scopeType: {
        '1': '无限次'
      },
      costType: {
        '1': '总金额',
        '2': '充电费',
        '3': '服务费',
      }
    }
  }
}
</script>